import Config from 'Constants/AppConfig.js'
import Nprogress from 'nprogress'
import Vue from 'vue'
import axios from 'axios'
import { store } from '../store/store.js'
import the_Api_urls from 'Constants/ApiURL.js'

let Api = axios.create({
    baseURL: Config.API_URL
})

let ApiURL = the_Api_urls

Api.defaults.withCredentials = true

// before a request is made start the Nprogress
Api.interceptors.request.use((config) => {
    Nprogress.start()
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // config.headers['Authorization'] = `Bearer ${store.state.auth.token}`
    config.headers['x-auth-token'] = store.state.auth.token;
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['semester-id'] = localStorage.getItem('semester_id') ?? 2

    return config
})

function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

// before a response is returned stop Nprogress
Api.interceptors.response.use(
    (response) => {
        // console.log( response );
        Nprogress.done()
        if( response.config.method != 'get' && response.data.message ){
            if (  response.status <=299 && response.status >= 200  ) {
                Vue.notify({
                    group: 'Response',
                    type: 'success',
                    text: response.data.message,
                    duration: 8000
                });
            }else{
                Vue.notify({
                    group: 'Response',
                    type: 'error',
                    text: response.data.message,
                    duration: 8000
                })
            }
        }
        
        return response
    },
    (err) => {
        Nprogress.done()
        if (err.response.status == 401) {
            store.dispatch('logoutUser')
        }

        Vue.notify({
            group: 'Response',
            type: 'error',
            text: err.response.data.error_message,
            data: err.response.data.errors ?? [],
            duration: 9000
        })
    }
)

export { ApiURL }
export default Api
